import React from 'react';
import I18n from 'i18n-js';
import { RCAlertBox, RCButton, RCStarRatingSelector } from '@reverbdotcom/cadence/components';
import FormGroupWithInput from '@reverbdotcom/commons/src/components/form_group_with_input';
import UrlHelpers from './shared/url_helpers';
import CoreClient from '../lib/core_client';
import { ReviewGuidelines, ReviewWarning } from './csp/components/csp_review_button';

interface ReviewErrors {
  rating?: string;
  body?: string;
}
interface Props {
  cspSlug: string;
}

export function ProductReviewForm(props: Props) {
  const { cspSlug } = props;
  const [rating, setRating] = React.useState(0);
  const [title, setTitle] = React.useState('');
  const [body, setBody] = React.useState('');
  const [showSuccessMessage, setShowSuccessMessage] = React.useState(false);
  const [errors, setErrors] = React.useState<ReviewErrors>({});

  function submit(e: React.ChangeEvent<HTMLFormElement>) {
    e.preventDefault();

    const data = {
      rating,
      body,
      title,
    };

    CoreClient.post(UrlHelpers.cspReviewsUrl(cspSlug, null, null), data).then(() => {
      setShowSuccessMessage(true);
    }).catch((e) => {
      if (e.data.errors.rating) {
        setErrors({ rating: I18n.t('discovery.productReviews.header.errorMessage.rating') });
      } else if (e.data.errors.body) {
        setErrors({ body: I18n.t('discovery.productReviews.header.errorMessage.body') });
      }
    });
  }

  if (showSuccessMessage) {
    return (
      <div className="mb-8">
        <RCAlertBox type="success">
          {I18n.t('discovery.productReviews.header.successMessage')}
        </RCAlertBox>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="mb-8">
      <h4 className="weight-bold mb-2">
        {I18n.t('discovery.cspReviewButton.writeAReview')}
      </h4>
      <RCStarRatingSelector
        onSelect={(value) => setRating(value)}
        rating={rating}
        inputName="csp-review-rating"
        inputId="csp-review-rating"
        label={I18n.t('discovery.cspReviewButton.yourRating')}
        errorText={errors.rating}
      />
      <FormGroupWithInput
        inputName="title"
        label={I18n.t('discovery.cspReviewButton.reviewTitle')}
        updateField={(value) => setTitle(value.title)}
        value={title}
        tagOptional
      />
      <FormGroupWithInput
        inputName="review"
        label={I18n.t('discovery.cspReviewButton.yourReview')}
        inputType="textarea"
        updateField={(value) => setBody(value.review)}
        value={body}
        errorText={errors.body}
      />
      <div className="mb-4">
        <RCButton
          isSubmit
          variant="primary"
        >
          {I18n.t('discovery.cspReviewButton.postReview')}
        </RCButton>
      </div>
      <ReviewWarning review={body} />
      <ReviewGuidelines />
    </form>
  );
}
